<template>
  <article v-if="null !== category.promotion" class="promotion-item">
    <MyLink
      name="category"
      :params="{ categorySlug: category.slug }"
      class="promotion-item__picture"
    >
      <img
        :src="category.getImageUrl('catalogImage')"
        :alt="category.getName()"
      />
    </MyLink>
    <div class="promotion-item__container">
      <div class="promotion-item__content">
        <p class="promotion-item__data">
          {{ normalizeDate(category.promotion.period.startAt) }} -
          {{ normalizeDate(category.promotion.period.endAt) }}
        </p>
        <MyLink
          name="category"
          :params="{ categorySlug: category.slug }"
          class="promotion-item__title"
        >
          {{ category.getName() }}
        </MyLink>
      </div>
      <PromotionDaysLeft :days-left="getDaysLeft()" />
    </div>
  </article>
</template>

<script setup>
import PromotionDaysLeft from "~/modules/productCatalog/ui/pages/promotions/PromotionDaysLeft.vue";
import { Category } from "~/models/category.model";

const props = defineProps({
  category: { type: Category, required: false },
});

function getDaysLeft() {
  const diff =
    props.category.promotion.period.endAt - new Date().getTime() / 1000;

  if (diff < 0) {
    return;
  }

  return Math.round(diff / (60 * 60 * 24));
}
</script>

<style lang="scss" scoped>
.promotion-item {
  height: 100%;
  @include flex-container(column, flex-start);

  &__picture {
    height: 100%;
    overflow: hidden;

    @include flex-container(column, center, center);
    flex: 1 0 242px;

    & > img {
      width: 100%;
      display: flex;

      height: inherit;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
  }

  &__container {
    min-height: 160px;
    height: 100%;
    border-radius: 0 0 8px 8px;
    border: 1px solid var(--color-sky-light);
    background: white;

    @include flex-container(row, space-between);
  }

  &__content {
    width: max-content;
    padding: 24px 8px;

    @include flex-container(column, center);
    gap: 16px;
  }

  &__data {
    @include font(12, 16, 400);
    letter-spacing: 0.24px;
  }

  &__title {
    @include font(16, 22, 400);
    letter-spacing: 0.32px;
  }
}
</style>
